import { all } from "redux-saga/effects";
import { donHangChiTietSaga } from "./donHangChiTietSaga";
import { donHangSaga } from "./donHangSaga";
import { donHangSearchSaga } from "./donHangSearchSaga";
import { donHangViewChiTietSaga } from "./donHangViewChiTietSaga";

export default function* donHangSagaWrapper() {
    yield all([
        donHangSaga(),
        donHangSearchSaga(),
        donHangViewChiTietSaga(),
        donHangChiTietSaga()
    ]);
}